<template>
  <div id="app">
    <vue-progress-bar></vue-progress-bar>
    <router-view/>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="stylus">
  @import './assets/stylus/app.styl';
</style>



// WEBPACK FOOTER //
// src/App.vue